import { APICore } from './apiCore'

const api = new APICore()

function getQuestionTypes (params) {
  const baseUrl = '/question-type'
  return api.get(baseUrl, params)
}

function getQuestionType (id) {
  const baseUrl = `/question-type/${id}`
  return api.get(baseUrl, {})
}

function addQuestionType (params) {
  const baseUrl = '/question-type'
  return api.create(baseUrl, params)
}

function updateQuestionType (params) {
  const baseUrl = '/question-type'
  return api.update(baseUrl, params)
}

function deleteQuestionType (params) {
  const baseUrl = '/question-type'
  return api.delete(baseUrl, params)
}

export { getQuestionTypes, getQuestionType, addQuestionType, updateQuestionType, deleteQuestionType }
